const data = {
    "bolletta-online": {
      label: "Bollett@Online",
      description: "In questo box ti suggeriamo di attivare il servizio che spedisce la bolletta direttamente nella tua casella email, risparmiando carta, energie e denaro.",
      labelKeywords: ["cta", "bolletta", "online"],
      contentKeywords: ["cta", "bolletta", "online"],
      img: "./images/04-comunicazioni-02-cta-02-bollettaonline.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta con evidenziato il campo che invita il cliente a domiciliare la bolletta."
    },
}

export default data;